import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function OnboardSuccess() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const clientId = params.get("clientId");

  useEffect(() => {
    const t = setTimeout(() => navigate(`/app/edit-client/${clientId}`), 3000);
    return () => clearTimeout(t);
  }, [clientId, navigate]);

  return (
    <div style={s.wrap}>
      <style>{`@keyframes pop { 0%{transform:scale(0.6);opacity:0} 70%{transform:scale(1.15)} 100%{transform:scale(1);opacity:1} }`}</style>
      <div style={s.icon}>✅</div>
      <div style={s.title}>WhatsApp Connected!</div>
      <div style={s.sub}>Dealer ka WhatsApp Business account successfully link ho gaya.</div>
      <div style={s.loader}>
        <div style={s.loaderBar} />
      </div>
      <div style={s.hint}>Redirecting back to client...</div>
    </div>
  );
}

const s = {
  wrap: {
    display: "flex", flexDirection: "column", alignItems: "center",
    justifyContent: "center", minHeight: "100vh", gap: 12,
    background: "var(--bg-base, #0f1117)", padding: 24, textAlign: "center",
  },
  icon: { fontSize: 56, animation: "pop 0.5s ease forwards" },
  title: { fontSize: 22, fontWeight: 700, color: "var(--text-primary, #fff)", marginTop: 8 },
  sub: { fontSize: 14, color: "var(--text-muted, #888)", maxWidth: 320, lineHeight: 1.6 },
  loader: {
    width: 200, height: 3, background: "rgba(255,255,255,0.1)",
    borderRadius: 99, overflow: "hidden", marginTop: 24,
  },
  loaderBar: {
    height: "100%", width: "100%",
    background: "var(--accent-green, #34c759)",
    animation: "loaderAnim 3s linear forwards",
    transformOrigin: "left",
  },
  hint: { fontSize: 12, color: "var(--text-muted, #666)" },
};
